import React from 'react';
import { buildElementStyling } from '../utils';
const RichTextParagraph = ({ children, value, removeEmptyParagraphs }) => {
    var _a, _b;
    const nodeChildrenText = (_b = (_a = value === null || value === void 0 ? void 0 : value.children) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text;
    if (removeEmptyParagraphs && nodeChildrenText) {
        if (nodeChildrenText.trim() === '')
            return null;
    }
    const { className, style } = buildElementStyling({
        baseClass: 'richTextParagraph',
        value,
    });
    return (React.createElement("p", { style: style, className: className }, children));
};
RichTextParagraph.displayName = 'RichTextParagraph';
export default RichTextParagraph;
//# sourceMappingURL=Paragraph.js.map